import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../axios/interceptor';
import openNotification from '../../../components/notification';

const initialState = {
    birthdays: [],
    anniversaries: [],
    upcoming: [],
    loading: false,
    error: null,
};

export const slice = createSlice({
    name: 'birthdayCalendar',
    initialState,
    reducers: {
        setEvents: (state, action) => {
            state.birthdays = action.payload.birthdays || [];
            state.anniversaries = action.payload.anniversaries || [];
        },
        setUpcoming: (state, action) => {
            state.upcoming = action.payload || [];
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const getBirthdayEvents = createAsyncThunk('getBirthdayEvents', (data, { dispatch }) => {
    dispatch(setLoading(true));
    axios.post('/birthday-calendar/events', data).then((response) => {
        if (response.data.isSuccess) {
            dispatch(setEvents({ birthdays: response.data.birthdays, anniversaries: response.data.anniversaries }));
        } else {
            dispatch(setEvents({ birthdays: [], anniversaries: [] }));
        }
    }).catch((error) => {
        openNotification({ message: error.message, type: 'error' });
    }).finally(() => {
        dispatch(setLoading(false));
    });
});

export const getUpcomingEvents = createAsyncThunk('getUpcomingEvents', (data, { dispatch }) => {
    dispatch(setLoading(true));
    axios.post('/birthday-calendar/upcoming', data).then((response) => {
        if (response.data.isSuccess) {
            dispatch(setUpcoming(response.data.upcoming));
        } else {
            dispatch(setUpcoming([]));
        }
    }).catch((error) => {
        openNotification({ message: error.message, type: 'error' });
    }).finally(() => {
        dispatch(setLoading(false));
    });
});

export const { setEvents, setUpcoming, setLoading, setError } = slice.actions;

export default slice.reducer;
